import React, { useRef, useState } from 'react';
import {
  IconButton,
  ImageList,
  ImageListItem,
  Popover,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Apps as AppsIcon } from '@material-ui/icons';

import useUser from 'src/hooks/useUser';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    padding: theme.spacing(2),
    width: 300
  },
  button: {
    width: 84,
    '&:hover': {
      '& p': {
        whiteSpace: 'normal'
      }
    }
  },
  buttonRoot: {
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#e8f0fe'
    }
  },
  buttonLabel: {
    flexDirection: 'column'
  },
  img: {
    height: 30
  },
  title: {
    width: 76,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));

const AppLauncher = () => {
  const classes = useStyles();
  const { user } = useUser();
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <IconButton ref={ref} onClick={handleOpen}>
        <AppsIcon style={{ color: '#FFFFFF', fontSize: 20 }} />
      </IconButton>
      <Popover
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
      >
        <div className={classes.root}>
          <ImageList className={classes.gridList} cols={3} rowHeight={96}>
            {user.available_apps.map((app) => (
              <ImageListItem key={app.link}>
                <IconButton
                  classes={{
                    root: classes.buttonRoot,
                    label: classes.buttonLabel
                  }}
                  className={classes.button}
                  component="a"
                  href={app.link}
                  target="_blank"
                  size="medium"
                >
                  <img src={app.image} className={classes.img} />
                  <Typography
                    variant="body2"
                    className={classes.title}
                    color="textPrimary"
                  >
                    {user.language === 'ja' ? app.name : app.name_en}
                  </Typography>
                </IconButton>
              </ImageListItem>
            ))}
          </ImageList>
        </div>
      </Popover>
    </>
  );
};

export default AppLauncher;
